import { Alert, Button } from '@mui/material';
import React, { useState } from 'react';
import Modal from '../elements/Modal';
import CategoryForm from './CategoryForm';

export default function EditCategory({
  category,
  fetchData,
  setMessage,
  setSnackbarOpen,
  token,
}) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  const handleSubmit = async (values) => {
    setError(null);
    const formData = new FormData();
    formData.append('name', values.name);
    formData.append('description', values.description);
    formData.append('insights', values.insights);
    formData.append('showMdBadge', values.showMdBadge);
    formData.append('hide', values.hide);
    formData.append('tag', values.tag);
    
    if(values.categoryDetails.length > 0){
      values.categoryDetails.forEach((field, index) => {
        if(field !== ''){
          formData.append(`categoryDetails[]`, field.toLowerCase());
        }
      });
    } 

    if (values.image) {
      formData.append('image', values.image);
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/v2/categories/${category.id}`,
        {
          method: 'PUT',
          body: formData,
          headers: { Authorization: token },
        }
      );

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error.message);
      }
      setSnackbarOpen(true);
      setMessage('Category updated successfully');
      fetchData();
      handleClose();
    } catch (error) {
      setError('Failed to update category. ' + error.message);
    }
  };

  return (
    <>
      <Button
        variant="text"
        sx={{ cursor: 'pointer', textTransform: 'none', fontSize: 'inherit' }}
        onClick={handleClickOpen}>
        Edit Category
      </Button>

      <Modal
        open={open}
        width={'sm'}
        modalTitle="Edit category"
        handleClose={handleClose}>
        {error && <Alert severity="error">{error}</Alert>}
        <CategoryForm
          category={category}
          onSubmit={handleSubmit}
          token={token}
        />
      </Modal>
    </>
  );
}
